import React from "react";
import cname from "../../style.module.scss";
import { ThePrincipleOfSpectrophotometryImage } from "../../SpectrophotometerImages";
import { PlainText as _PlainText } from "@learningblocks/storybook-components";
import { HighlightProvider as SharedHighlightProvider } from "@learningblocks/shared-components";
import { useHighlight } from "@learningblocks/shared/glossary";
const PlainText = _PlainText as React.FC<any>;
export const Content = () => {
  const { onPlainTextClick } =
    React.useContext(SharedHighlightProvider.Context) || useHighlight();

  return (
    <div className={cname.content}>
      <p>
        <PlainText
          text="The basic principle behind <highlight
        contentid='recvhMdItb7Kru9X3'>spectrophotometry</highlight> is that
        light interacts with matter."
          onClickHighlight={onPlainTextClick}
        />
      </p>
      <div className={cname.content_image_container}>
        <div className={cname.content_image}>
          <ThePrincipleOfSpectrophotometryImage />
        </div>
        <div className={cname.caption}>
          Figure 1: Principle of spectrophotometry. Light is absorbed by a
          substance (depicted as red dots) within a solution. At a higher
          concentration, more of the light that enters is absorbed, so less
          light exits the solution. At a lower concentration, less light is
          absorbed, and more light exits the solution. Notice how the yellow
          arrows exiting the tubes are different sizes in panels A and B.
        </div>
      </div>
      <div>
        <p>
          <PlainText
            onClickHighlight={onPlainTextClick}
            text={`
                        For example, as light passes through a solution containing a
                        certain substance, some of the light moves through without
                        interacting with the substance (i.e., it is
                        <highlight contentid='rec0LokoYxMu5KTMZ'>transmitted</highlight>),
                        whereas other light is taken up by the substance (i.e., it is
                        <highlight contentid='recCikNVKhBsDXvcX'>absorbed</highlight>).
                        In other words <b>light becomes less intense as it
                        travels through a solution</b>.
                        The higher the concentration of a substance in a solution,
                        the more light is absorbed (Figure 1).`}
          />
        </p>
        <p>
          Measuring absorbance is exactly what a spectrophotometer does best.
        </p>
        <PlainText
          onClickHighlight={onPlainTextClick}
          text={`
                          <p>
                              A spectrophotometer measures how much light of a certain
                              wavelength is absorbed by a substance in solution, which
                              (when the reading is compared to a known
                              <highlight contentid='recmdgDcMwy3FrMpi' >standard</highlight>) allows us
                              to determine its concentration.
                          </p>

                    `}
        />
      </div>
    </div>
  );
};
